import Tag from './Tag';

export { Props } from './Tag';
export default Tag;
